module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_8023.dccf33d7.png";